/**
 * @tabler/icons-react v2.44.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconCornerDownRightDouble = createReactComponent(
  "corner-down-right-double",
  "IconCornerDownRightDouble",
  [
    ["path", { d: "M4 5v6a3 3 0 0 0 3 3h7", key: "svg-0" }],
    ["path", { d: "M10 10l4 4l-4 4m5 -8l4 4l-4 4", key: "svg-1" }]
  ]
);

export { IconCornerDownRightDouble as default };
//# sourceMappingURL=IconCornerDownRightDouble.js.map
